import React from 'react'
import { H1 } from '@fs/zion-ui'
import { useParams } from '@fs/zion-router'
import { type PID, type RelationshipType } from '@fs/zion-tree-types'
import { useTranslation } from 'react-i18next'
import { type FilterChoiceType } from '../../../types'
import { changelogSubheaderKeyMap } from '../../../../common/translationsKeyMaps'
import useFilterType from '../../../lib/useFilterType'

export default function SubHeader(): JSX.Element {
  const [t] = useTranslation()
  const { relationshipType, relationshipId } = useParams() as {
    relationshipType?: RelationshipType
    relationshipId?: PID
  }
  const filterType = useFilterType()

  const relationshipSubHeaderMap = {
    couple: 'couple-relationship',
    'parent-child': 'parent-child-relationship',
    association: 'association',
  } as const

  let subHeaderKey:
    | FilterChoiceType
    | (typeof relationshipSubHeaderMap)[keyof typeof relationshipSubHeaderMap]
    | undefined = filterType
  let subHeaderKeyType = 'filter-by'

  if (relationshipId) {
    subHeaderKeyType = 'label'
    subHeaderKey = relationshipType ? relationshipSubHeaderMap[relationshipType] : undefined
  }

  const subHeader = t(changelogSubheaderKeyMap[`${subHeaderKeyType}_${subHeaderKey}`])

  return (
    <H1 size="H5" data-testid="heading">
      {subHeader}
    </H1>
  )
}
